import ServicesImageAbstract from './ServicesImageAbstract';
import Math_ from 'utils/Math';

export default class ServicesImagesSEO extends ServicesImageAbstract {
	constructor( $wrapper ) {
		super( $wrapper );
		this.setupTimelines();
		this.init();
	}

	setupTimelines() {
		this.objects = [];
		this.timelines = [];
		for ( let i = 0; i < 3; i++ ) {
			this.objects.push( {
				size: 0.25,
			} );
			gsap.set( this.objects[ i ], {
				size: 0.25,
			} );
			this.timelines[ i ] = gsap.to( this.objects[ i ], {
				duration: 10,
				size: 1,
				repeat: -1,
				repeatRefresh: false,
				yoyo: true,
				ease: 'power2.inOut',
				paused: true,
			} );
			this.timelines[ i ].progress( i / 3 );

		}
	}

	updateCanvas() {

		const blue = '#4545FF',
			numShapes = 3,
			opacities = [ 0.5,
				0.5,
				1 ];

		// RESET
		this.ctx.resetTransform();
		this.ctx.clearRect( 0, 0, this.size, this.size );
		this.ctx.fillStyle = blue;
		this.ctx.globalCompositeOperation = 'source-over';
		let velocity = this.velocity / 50;
		velocity = velocity > 0 ? velocity + 1 : velocity - 1;
		velocity = Math_.clamp( velocity, -20, 20 );
		if ( velocity > -1 && velocity < 1 ) {
			velocity = 1;
		}
		const rectSize = this.size * 0.5;

		for ( let i = 0; i < numShapes; i++ ) {

			this.timelines[ i ].timeScale( velocity );
			const sizePercent = this.objects[ i ].size;

			this.ctx.globalAlpha = opacities[ i ];
			this.ctx.resetTransform();
			this.ctx.beginPath();
			this.ctx.moveTo( 0, this.size );
			this.ctx.rect( i * ( ( this.size - ( rectSize ) ) / 2 ), this.size * ( 1 - sizePercent ), rectSize, this.size * sizePercent );
			this.ctx.fill();
		}
	}
	pause() {
		super.pause();
		this.timelines.forEach( ( tw ) => {
			tw.pause();
		} );
	}
	resume() {
		super.resume();
		this.timelines.forEach( ( tw, i ) => {
			tw.timeScale( 1 ).progress( i / 3 );
			tw.play();
		} );
	}

	destroy() {
		this.timelines.forEach( ( timeline ) => {
			timeline.kill();
		} );
		super.destroy();
	}
}
